import { render, staticRenderFns } from "./ProjectOffers.vue?vue&type=template&id=47852bcb&"
import script from "./ProjectOffers.vue?vue&type=script&lang=js&"
export * from "./ProjectOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports